import * as React from "react";
import { SVGProps } from "react";
const SvgChartBar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 13c0-.5-.5-1-1-1H4c-.6 0-1 .5-1 1v14c0 .5.4 1 1 1h5c.5 0 1-.5 1-1V13Zm19-4c0-.5-.5-1-1-1h-5c-.5 0-1 .5-1 1v18c0 .5.5 1 1 1h5c.5 0 1-.5 1-1V9Zm-9.5-4c0-.6-.5-1-1-1h-5c-.5 0-1 .4-1 1v22c0 .5.5 1 1 1h5c.5 0 1-.5 1-1V5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgChartBar;
